/** 系统自带的 projectCode */
export const PROJECT_CODE = {
  /** 深证 */
  Shenzhen: "SZ",
  /** 天津 */
  Tianjin: "Tianjin",
  /** 苏州 */
  Suzhou: "Suzhou",
  /** 江门 */
  Jiangmen: "Jiangmen",
  /** 宜昌 */
  Yichang: "Yichang",
  /** 北海 */
  Beihai: "Beihai",
  /** 广州 */
  Guangzhou: "Guangzhou",
  Ziyang: "Ziyang",
  Dazhou: "Dazhou",
  Shaoxing: "Shaoxing",
  Chongzuo: "Chongzuo",
  Baise: "Baise",
  Hezhou: "Hezhou",
  Fangchenggang: "Fangchenggang",
  /** 学平险 */
  Sichuan_Xueping: "Sichuan_Xueping",
  Xiaoyaoxiang: "Xiaoyaoxiang",
  Guigang: "Guigang",
  /** 晨曦-黄冈 */
  Huanggang: "Huanggang",
  /** 梅州 */
  Meizhou: "Meizhou",
  Tianjin2025: "Tianjin_25",
  Hangzhou_26: "Hangzhou_26",
  Foshan_26: "Foshan_26",
  Xiamen_26: "Xiamen_26"
};

export const VERSION = import.meta.env.VITE_MODE === "prod" ? "release" : "trial";
export const APP_ID = 'wx9db8d35c8bf0d820'
export const ALIPAY_APP_ID = '2021006112644114'